/**
 * Shared PLP helpers to detect and exclude prescription (RX) products/variants
 * from color carousels and price sorting — aligned with PDP logic.
 */
(() => {
    if (window.poPlpRxUtils) {
        return;
    }

    /**
     * @param {unknown} value
     * @returns {string}
     */
    const normalize = (value) => (value || "").toString().trim();

    /**
     * @param {object} hit - Algolia product hit
     * @returns {boolean}
     */
    const isRxHit = (hit = {}) => {
        const handle = normalize(hit.handle).toLowerCase();
        if (/(?:^|-)rx(?:-|$)/.test(handle)) {
            return true;
        }

        const title = normalize(hit.title);
        if (/\bRX\b/i.test(title)) {
            return true;
        }

        const variantTitle = normalize(
            hit.variant_title || hit.meta?.custom?.variant_title
        );
        if (variantTitle.toUpperCase().includes("RX")) {
            return true;
        }

        return false;
    };

    /**
     * @param {object[]} hits
     * @returns {object[]}
     */
    const filterNonRxHits = (hits = []) => {
        if (!Array.isArray(hits) || hits.length === 0) {
            return [];
        }

        const nonRxHits = hits.filter((hit) => hit && !isRxHit(hit));
        return nonRxHits.length > 0 ? nonRxHits : hits.slice();
    };

    window.poPlpRxUtils = {
        isRxHit,
        filterNonRxHits,
    };
})();
